import React from "react";
import { NextPage } from "next";
import dynamic from "next/dynamic";
import { useFrontAnonymous } from "lib/hooks/useFrontAnonymous";
import GeneralHead from "components/front/head/GeneralHead";
import { FrontAuthProps, withFrontAuth } from "lib/hoc/withFrontAuth";
import { Props as PasswordResetRequestSectionProps } from "components/front/password/reset/PasswordResetRequestSection";
import { Props as HeaderProps } from "components/front/layout/Header";
import { Props as FooterProps } from "components/front/layout/Footer";
import { Props as GeneralFootProps } from "components/front/layout/GeneralFoot";
import Main from "components/front/layout/Main";
import RootSection from "components/front/layout/RootSection";

const Header = dynamic<HeaderProps>(() => import("components/front/layout/Header").then((m) => m.Header));
const PasswordResetRequestSection = dynamic<PasswordResetRequestSectionProps>(
  () => import("components/front/password/reset/PasswordResetRequestSection")
);
const Footer = dynamic<FooterProps>(() => import("components/front/layout/Footer"));
const GeneralFoot = dynamic<GeneralFootProps>(() => import("components/front/layout/GeneralFoot").then((m) => m.GeneralFoot));

const PasswordResetPage: NextPage<FrontAuthProps> = () => {
  useFrontAnonymous();
  return (
    <>
      <GeneralHead screenName={"パスワード再設定"} />
      <Header />
      <Main>
        <RootSection>
          <PasswordResetRequestSection />
        </RootSection>
      </Main>
      <Footer />
      <GeneralFoot />
    </>
  );
};
export default withFrontAuth(PasswordResetPage);
